import { UserContext } from "../../context";
import React from "react";
import { Trans } from "react-i18next";
import { Box, Text, Button } from "@chakra-ui/react";
import { useHistory, useRouteMatch } from "react-router-dom";
import icons from "../../assets/icons";

const EventLink = ({ event, index }) => {
  let subCategory = "Events";
  let { url } = useRouteMatch();
  const { userData, setUserData } = React.useContext(UserContext);
  let history = useHistory();
  const GroupIcon = icons[event?.name];
  const setUserEvent = () => {
    setUserData({ ...userData, event: event });
    history.push(`${url}/${event.id}`);
  };
  if (event.children && event.children.length > 0) {
    subCategory = "ElementTree";
  }
  return (
    <Box key={event.id} layerStyle={"kioskGridItem"}>
      <Button
        variant={"unstyled"}
        layerStyle={"kioskGridItem.Button"}
        onClick={setUserEvent}
        data-testid={`event-item-${index}`}
      >
        <Box layerStyle={"kioskGridItem.Icon"}>
          {GroupIcon ? (
            <Box layerStyle={"kioskGridItem.Image"}>
              <GroupIcon height={"50px"} />
            </Box>
          ) : (
            <Box layerStyle={"kioskGridItem.Text"}>
              <Text fontSize={"4xl"}>{event?.name?.[0]}</Text>
            </Box>
          )}
        </Box>
        <Text layerStyle={"kioskGridItem.Name"} noOfLines={2}>
          <Trans i18nKey={`${subCategory}.${event?.name}`} ns={subCategory}>
            {event?.name}
          </Trans>
        </Text>
      </Button>
    </Box>
  );
};

export default EventLink;
